import Vue from 'vue';
import Vuex from 'vuex';
import root from '@/store/root/root.js'
import VuexPersistence from 'vuex-persist'
/* const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage
}) */
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    ...root.state
  },
  getters: {
    ...root.getters
  },
  mutations: {
    ...root.mutations
  },
  actions: {
    ...root.actions
  },
  // plugins: [vuexLocal.plugin]
});

export default store;
